import {useEffect, useState} from 'react';
import cn from 'classnames';
import {BottomSheet} from 'react-spring-bottom-sheet';
import Accordion from '../../../components/mazraeKit/accordion';
import {IFiltersData, filtersData} from './utils';
import {useLabListingFilters} from '../../../hooks/filters/useLabListingFilter';
import useGetInputLists from '../../../services/hookService/getInputLists/useGetInputLists';
import SubCategoryCards from '../../../module/newShop/home/subInputGroups';

interface IFiltersKeyValuePairs {
  guid: string;
  title: string;
  code: number;
}
export interface IFilters {
  categories: Array<IFiltersKeyValuePairs>;
  sorting: string;
  has_discount: boolean;
  in_person_possibility: boolean;
  has_delivery: boolean;
  has_guarantee: boolean;
}
const LabListingBottomSheet = ({
  openBottomSheet,
  setOpenBottomSheet,
  labInputGroup,
}: {
  labInputGroup: IInputGropuList;
  openBottomSheet: boolean;
  setOpenBottomSheet: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const [openAccordion, setOpenAccordion] = useState<boolean>(false);
  const {labListingFilters, resetLabListing, setFiltersLabListing} =
    useLabListingFilters();

  const [filters, setFilters] = useState({
    categories: labListingFilters.input_guid,
    sorting: labListingFilters.order_by,
  });

  const {data: labCategoryList} = useGetInputLists({
    input_group__guid: labInputGroup.guid,
  });

  const sortingHandler = (sortingItem: IFiltersData) => {
    setFilters(prev => {
      return {...prev, sorting: sortingItem.value};
    });
  };

  const checkBoxHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFilters(prev => {
      return {...prev, [event.target.name]: event.target.checked};
    });
  };
  const handleApplyFilters = () => {
    const filtersData = {
      input_guid: filters.categories,
      order_by: filters.sorting,
    };
    setFiltersLabListing(filtersData);
    setOpenBottomSheet(false);
  };

  const handleClearFilters = () => {
    resetLabListing();
    setOpenBottomSheet(false);
  };

  useEffect(() => {
    setFilters({
      categories: labListingFilters.input_guid,
      sorting: labListingFilters.order_by,
    });
  }, [openBottomSheet, labListingFilters]);
  return (
    <>
      <BottomSheet
        onDismiss={() => {
          setOpenBottomSheet(false);
        }}
        open={openBottomSheet}
        blocking={true}
        snapPoints={({minHeight, maxHeight}) => [minHeight, maxHeight / 0.8]}
        className="transition ease-in-out delay-250"
      >
        <div className="pt-2 pb-3 max-h-[80dvh] overflow-y-auto relative">
          <div className="flex pt-2 pb-3 bg-white justify-between border-b px-3 sticky top-[-10px]">
            <p className="font-Medium">فیلتر</p>
            <i
              className="text-xl icon-nameClose-remove"
              onClick={() => setOpenBottomSheet(false)}
            />
          </div>
          {labCategoryList && (
            <div className="flex flex-col gap-3 px-3 mt-4">
              <span>نوع آزمایشگاه</span>
              <SubCategoryCards
                filters={filters}
                setFilters={setFilters}
                subInputGroupList={labCategoryList}
              />
            </div>
          )}
          <div className="flex items-center px-3 border-b">
            <Accordion
              accordionTitle="مرتب‌سازی بر اساس"
              setOpenAccordion={setOpenAccordion}
              openAccordion={openAccordion}
            >
              <div className="flex gap-2 justify-start pb-3">
                {filtersData.map(item => {
                  return (
                    <div
                      key={item.id}
                      className={cn(
                        'border-[1px] text-sm text-farm-shop-500 rounded-full border-farm-shop-500 w-fit py-2 px-2',
                        {
                          'bg-farm-shop-100': item.value === filters.sorting,
                        },
                      )}
                      onClick={() => sortingHandler(item)}
                    >
                      {item.title}
                    </div>
                  );
                })}
              </div>
            </Accordion>
          </div>
          <div className="sticky bottom-[-20px] z-10 py-2 bg-white border-t border-gray-200 ">
            <div className="flex flex-1 gap-2 px-3 mt-6">
              <button
                className="flex justify-center items-center w-3/5 rounded text-white py-2.5 bg-farm-shop-500"
                onClick={handleApplyFilters}
              >
                اعمال فیلترها
              </button>
              <button
                className="flex justify-center items-center w-2/5 rounded py-2.5 border-[1px] text-red-500 !border-red-500"
                onClick={handleClearFilters}
              >
                حذف فیلترها
              </button>
            </div>
          </div>
        </div>
      </BottomSheet>
    </>
  );
};

export default LabListingBottomSheet;
